import { Link } from "react-router-dom";

const entries = [
  {
    to: "/episodes",
    icon: "ri-film-line",
    title: "剧集导航",
    desc: "按故事篇章浏览全集剧情介绍",
  },
  {
    to: "/characters",
    icon: "ri-user-star-line",
    title: "角色大全",
    desc: "主角、反派与配角的资料分析",
  },
  {
    to: "/news",
    icon: "ri-newspaper-line",
    title: "最新资讯",
    desc: "动漫动态、周边与粉丝活动",
  },
];

export default function QuickLinks() {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <h2 className="font-heading text-base font-bold text-foreground-950">分类快捷入口</h2>
      <div className="mt-4 space-y-3">
        {entries.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group flex items-center gap-3 rounded-md border border-background-200 bg-background-100 p-3 transition-colors hover:border-primary-300 hover:bg-primary-50"
          >
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
              <i className={`${entry.icon} text-lg`} />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block text-sm font-bold text-foreground-950">{entry.title}</span>
              <span className="block truncate text-xs text-foreground-500">{entry.desc}</span>
            </span>
            <i className="ri-arrow-right-s-line text-foreground-400 transition-colors group-hover:text-primary-600" />
          </Link>
        ))}
      </div>
    </div>
  );
}